import CarService from "../../../../services/abstract/CarService";
import CarServiceApi from "../../../../services/api/CarServiceApi";
import { OK } from "http-status-codes";
import React from "react";
import SMessage from "../../../../struct/message/SMessage";
import Select from "../../../../components/custom/select/Select";
import { addMessage } from "../../../../store/actions/messages";
import store from "../../../../store/store";

interface Props {
  value: App.ID | null;
  onChange: (value: App.ID | null) => void;
}
interface State {
  transmissions: Array<App.Car.Transmission>;
}

class TransmissionPickerContainer extends React.Component<Props, State> {
  private service: CarService;
  constructor(props: Props) {
    super(props);
    this.service = new CarServiceApi();
    this.state = {
      transmissions: [],
    };
  }
  public componentDidMount() {
    this.getTransmissiones();
  }

  private async getTransmissiones() {
    const { data, status, errors } = await this.service.getTransmissions();
    if (status === OK) {
      this.setState({
        transmissions: data,
      });
    } else {
      errors.forEach((error) =>
        store.dispatch(addMessage(new SMessage(error)))
      );
    }
  }

  public render() {
    return (
      <Select
        selected={this.props.value}
        placeholder="Коробка передач"
        multiselect={false}
        onChange={this.props.onChange}
        options={this.state.transmissions
          .sort((a, b) => {
            return a.name > b.name ? 1 : -1;
          })
          .map((e) => {
            return { id: e.id, name: `${e.name} ${e.gearsNumber} п.` };
          })}
      />
    );
  }
}

export default TransmissionPickerContainer;
